import Vuex from 'vuex';
import Vue from 'vue';
import gql from 'graphql-tag';

if (Vue.localStorage) {
    Vue.localStorage.selectedLanguage = {
        type: String,
        default: null,
    };
}

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        languages: {},
        language: null,
        loaded: false,
        translations: {},
        translationsLoadingPromise: null,
    },
    mutations: {
        setLanguages(state, value) {
            let indexedLanguages = {};

            for (let language of value) {
                indexedLanguages[language.lang] = language;
            }

            state.languages = indexedLanguages;
        },
        setLanguage(state, value){
            if (Vue.localStorage) {
                Vue.localStorage.set('selectedLanguage', value);
            }
            state.language = value;

            this.dispatch('loadTranslations');
        },
        setLoaded(state, value) {
            state.loaded = value;
        },
        setTranslations(state, value) {
            state.translations = value ? value : {};
        },
        setTranslationsLoadingPromise(state, value) {
            state.translationsLoadingPromise = value;
        },
    },
    getters: {
        getLanguage(state) {
            return state.language;
        },
    },
    actions: {
        loadLanguages({commit}) {
            return Vue.$graphql.query({
                query: gql`
                    query getLanguages {
                        getLanguages {
                            name
                            lang
                            isDefault
                        }
                    }
                `
            }).then(
                r => r.data
            ).then(data => {
                if (data.getLanguages) {
                    commit('setLanguages', data.getLanguages);
                }
            }).catch(
                () => {}
            );
        },
        loadTranslations({state, commit}) {
            let promise = Vue.$graphql.query({
                query: gql`
                    query getLanguageTranslations($lang: String!) {
                        getLanguageTranslations(lang: $lang) {
                            labels
                        }
                    }
                `,
                variables: {
                    lang: state.language,
                },
            }).then(
                r => r.data
            ).then(data => {
                if (data.getLanguageTranslations) {
                    commit('setTranslations', data.getLanguageTranslations.labels);
                }
            }).catch(
                () => {
                    commit('setTranslations', {});
                }
            );

            commit('setTranslationsLoadingPromise', promise);

            return promise;
        },
    },
});